export const RoundedBtn = ({ text = "Submit", className, onClick, isDesabled }) => {
  return <button className={`rounded-pill px-3 btn ${className}`} onClick={onClick} isDesabled={isDesabled} title={text} >{text}</button>
};

